import React     from 'react';
import PropTypes from 'prop-types';

import ActorProfileRecommendations from '../ActorProfileRecommendations';
import ActorSedcards               from './ActorSedcards';
import Awards                      from './Awards';
import Flux                        from '../../../flux/Flux';
import Freetext                    from '../ActorProfileOverview/Freetext';
import MyProfile                   from './MyProfile';
import TeaserBlock                 from '../../Homepage/Block/TeaserBlock';
import TileGrid                    from '../../TileGrid/TileGrid';
import ProfileInterviewsBlock      from '../../Profile/ProfileInterviewsBlock';
import ProfileOverviewVideos, {
    GridTypes
}                                  from '../../Profile/ProfileOverviewVideos';
import ProfileOverviewVideosBlock  from '../../Profile/ProfileOverviewVideosBlock';

import UrlBuilder                  from '../../../utils/UrlBuilder';

const ProfileAboutMe = (props) => {

    const { actorData, navigateTo, sedcard, setSedcard } = props;

    const videoBlock = (
        <ProfileOverviewVideos
            actorId          = {actorData.id}
            actorName        = {actorData.name || ''}
            headlineType     = {Flux.Constants.Headlines.h4}
            includeClassic   = {true}
            lazyImageLoading = {true}
            navigateTo       = {navigateTo}
            type             = {actorData.promoteClassicContent ? GridTypes.CLASSIC : GridTypes.NEWEST}
        />
    );

    const teaser = (
        <div style={{marginBottom: '25px'}}>
            <TeaserBlock teaserContext="promotion" />
        </div>
    );

    const contentTileConfig = {
        ...actorData.contentTileGridConfig,
        navigateTo: navigateTo,
    };

    const modelInfoBoxes = actorData.contentTileGridConfig ? (
        <section className='container-block--actor-profile-about-boxes-texts'>
            <TileGrid
                gridConfig      = {contentTileConfig}
                gridMode        = "TILEGRID_MODE_GRID"
                guestIsLoggedIn = {Flux.Guest.isLoggedIn()}
            />
        </section>
    ) : null;

    const actorHasFreeText = Boolean(actorData.freeText || actorData.freeTextHeadline || actorData.freeTextBody);

    return (
        <>

            <ActorSedcards
                actorData  = {actorData}
                navigateTo = {navigateTo}
                sedcard    = {sedcard}
                setSedcard = {setSedcard}
            />

            {actorHasFreeText && <Freetext
                isCouple         = {actorData.isCouple}
                isOverview       = {false}
                freeText         = {actorData.freeText}
                freeTextHeadline = {actorData.freeTextHeadline}
                freeTextBody     = {actorData.freeTextBody}
            />}

            {(actorData.isVideoActor && actorData.isFeedAvailable) &&
                <ProfileOverviewVideosBlock
                    buttonLink            = {UrlBuilder.buildActorProfileVideosUrl(actorData.name)}
                    navigateTo            = {navigateTo}
                    profileOverviewVideos = {videoBlock}
                />
            }

            <MyProfile actorData = {actorData}/>

            {actorData.awards.length > 0 &&
                <Awards  awards={actorData.awards} />
            }

            {teaser}

            <ProfileInterviewsBlock
                actorId   = {actorData.id}
                imageSize = {Flux.Constants.Interviews.IMAGE_SIZE_720}
            />

            {modelInfoBoxes}

            <ActorProfileRecommendations actorId={actorData.id} />

        </>
    );
};

ProfileAboutMe.propTypes = {
    actorData:         PropTypes.object.isRequired,
    navigateTo:        PropTypes.func.isRequired,
    sedcard:           PropTypes.object,
    setSedcard:        PropTypes.func,
};

export default ProfileAboutMe;
